import { MinzeElement } from 'minze'

export interface LvcCircleSettingIcon {}

export class LvcCircleSettingIcon extends MinzeElement {
  html = () => `
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.9643 21.7676C22.0787 21.486 24.1235 21.346 27.358 21.4299M34.0357 21.6424C33.1152 21.5815 32.5958 21.5264 31.7755 21.4828M31.7755 21.4828C31.7755 22.6167 30.6581 23.5563 29.4101 23.5563C28.1622 23.5563 27.358 22.5261 27.358 21.4299M31.7755 21.4828C31.7755 20.9046 31.5411 20.2773 31.1839 19.8777M27.358 21.4299C27.358 20.182 28.3964 19.3036 29.5832 19.3036C30.1766 19.3036 30.7181 19.5727 31.0541 19.9608M19.9466 30.2494C19.1263 30.2058 18.8848 30.1717 17.9643 30.1108M19.9466 30.2494C19.9466 29.1155 21.064 28.1759 22.3119 28.1759C23.5599 28.1759 24.3641 29.2061 24.3641 30.3023M19.9466 30.2494C19.9466 30.8276 20.181 31.4549 20.5382 31.8546M24.3641 30.3023C27.6098 30.1108 29.8549 30.428 34.0357 30.2694M24.3641 30.3023C24.3641 31.5502 23.3257 32.4286 22.1389 32.4286C21.5455 32.4286 21.004 32.1595 20.668 31.7714" stroke="#1E007D" stroke-width="2" stroke-linecap="round"/>
    <rect x="0.5" y="0.5" width="51" height="51" rx="25.5" stroke="#1E007D"/>
    </svg>
  `

  css = () => `
    
  `
}
